<mat-toolbar>
  <h1>Upload</h1>
</mat-toolbar>
<div class="drop-zone">
  <ngx-file-drop  dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" class="file-drop">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <span class="drop-message">Drop files here</span>
      <button mat-stroked-button (click)="openFileSelector()">Browse...</button>
    </ng-template>
  </ngx-file-drop>
  <div class="uploaded-list" *ngIf="!single">
    <mat-list>
      <mat-list-item *ngFor="let file of files">
        <mat-icon mat-list-icon color="warn" class="delete-icon" (click)="deleteFile(file)">delete_forever</mat-icon>
        <div mat-line>{{file.fileName}}</div>
        <div mat-line> {{file.contentType}} </div>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="actions" *ngIf="!single">
    <button mat-flat-button (click)="close()">Done</button>
  </div>
</div>
